import { render, staticRenderFns } from "./SolanCreateRubricButton.vue?vue&type=template&id=f2dd01b0&scoped=true&"
import script from "./SolanCreateRubricButton.vue?vue&type=script&lang=ts&"
export * from "./SolanCreateRubricButton.vue?vue&type=script&lang=ts&"
import style0 from "./SolanCreateRubricButton.vue?vue&type=style&index=0&id=f2dd01b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dd01b0",
  null
  
)

export default component.exports